import { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router";

import { setTokens } from "./JwtTokenManager";

/**
 * Component that automatically handles JWT tokens from URL parameters
 * Should be used at the app level to enable automatic authentication
 * from redirects with jwt_token and jwt_refresh_token parameters
 */
export function JwtTokenHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const [tokenProcessed, setTokenProcessed] = useState(false);

  useEffect(() => {
    // Prevent processing the same tokens multiple times
    if (tokenProcessed) return;

    const searchParams = new URLSearchParams(location.search);
    const jwtToken = searchParams.get("jwt_token");
    const jwtRefreshToken = searchParams.get("jwt_refresh_token");

    // Only process if we have at least a JWT token
    if (!jwtToken) {
      return;
    }

    setTokenProcessed(true);

    setTokens({
      token: jwtToken,
      refreshToken: jwtRefreshToken,
      success: () => {
        // Dispatch event to notify components that tokens have been loaded
        window.dispatchEvent(new Event("exec.tokensLoaded"));

        // Remove tokens from URL after successful authentication
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("jwt_token");
        newSearchParams.delete("jwt_refresh_token");

        const newUrl = `${location.pathname}${
          newSearchParams.toString() ? `?${newSearchParams.toString()}` : ""
        }`;

        navigate(newUrl, { replace: true });
      },
      error: () => {
        console.error("Failed to authenticate with JWT tokens from URL");
        // Still remove tokens from URL even on error
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("jwt_token");
        newSearchParams.delete("jwt_refresh_token");

        const newUrl = `${location.pathname}${
          newSearchParams.toString() ? `?${newSearchParams.toString()}` : ""
        }`;

        navigate(newUrl, { replace: true });
      },
    });
  }, [location, navigate, tokenProcessed]);

  // This component doesn't render anything
  return null;
}
